import { getInstance } from './instance';

type UserLike = { id: number; locale: string; email: string };

const setSentryUser = (newUser: Partial<UserLike> | null) => {
  const scope = getInstance()?.getCurrentScope?.();
  const { id, locale, email } = newUser || {};
  scope?.setUser(
    id ? { id: String(id), ...(email?.match(/@skilllab\.io$/) ? { email } : undefined) } : null,
  );
  scope?.setTag('page_locale', locale || document.documentElement.lang);
};

export default setSentryUser;
